import { forwardRef } from 'react';
import { useGlobalState } from '../../App/globalState';
import TitleWrapper from './style/titleWrapper';

const Title = forwardRef((props, ref) => {
  const { children, ...rest } = props;

  const { globalState } = useGlobalState();
  const { language } = globalState || {};

  return (
    <TitleWrapper {...rest} $language={language} ref={ref}>
      {children}
    </TitleWrapper>
  );
});

export default Title;
